import { makeAutoObservable } from 'mobx';
import {
  defaultPercentage,
  TeamsSortBy,
} from 'pages/iPriseV2/common/enum/TeamUserRoles';

export class SupportJobQueueService {
  mainTab = 0; // 0: Support Queue, 1: Team Lead Queue
  supportSubTab = 0; // 0: Pending, 1: Submitted Job Queue
  teamLeadSubTab = 0; // 0: New, 1: Assigned, 2: Ready for Review, 3: Approved

  // Support Queue Sub-tabs
  pendingPage = 0;
  pendingRowsPerPage = 50;
  submittedJobPage = 0;
  submittedJobRowsPerPage = 50;

  // Team Lead Queue Sub-tabs
  newPage = 0;
  newRowsPerPage = 50;
  assignedPage = 0;
  assignedRowsPerPage = 50;
  readyForReviewPage = 0;
  readyForReviewRowsPerPage = 50;
  approvedPage = 0;
  approvedRowsPerPage = 50;
  searchTerm = '';
  selectedSort = String(TeamsSortBy.NEWEST_FIRST);
  percentage = defaultPercentage;

  constructor() {
    makeAutoObservable(this);
  }

  setMainTab(tab: number) {
    this.mainTab = tab;
  }

  setSupportSubTab(tab: number) {
    this.supportSubTab = tab;
  }

  setTeamLeadSubTab(tab: number) {
    this.teamLeadSubTab = tab;
  }

  // Support Queue setters
  setPendingPage(page: number) {
    this.pendingPage = page;
  }
  setPendingRowsPerPage(rowsPerPage: number) {
    this.pendingRowsPerPage = rowsPerPage;
    this.pendingPage = 0;
  }

  setSubmittedJobPage(page: number) {
    this.submittedJobPage = page;
  }
  setSubmittedJobRowsPerPage(rowsPerPage: number) {
    this.submittedJobRowsPerPage = rowsPerPage;
    this.submittedJobPage = 0;
  }

  // Team Lead Queue setters
  setNewPage(page: number) {
    this.newPage = page;
  }
  setNewRowsPerPage(rowsPerPage: number) {
    this.newRowsPerPage = rowsPerPage;
    this.newPage = 0;
  }

  setAssignedPage(page: number) {
    this.assignedPage = page;
  }
  setAssignedRowsPerPage(rowsPerPage: number) {
    this.assignedRowsPerPage = rowsPerPage;
    this.assignedPage = 0;
  }

  setReadyForReviewPage(page: number) {
    this.readyForReviewPage = page;
  }
  setReadyForReviewRowsPerPage(rowsPerPage: number) {
    this.readyForReviewRowsPerPage = rowsPerPage;
    this.readyForReviewPage = 0;
  }

  setApprovedPage(page: number) {
    this.approvedPage = page;
  }
  setApprovedRowsPerPage(rowsPerPage: number) {
    this.approvedRowsPerPage = rowsPerPage;
    this.approvedPage = 0;
  }

  setSearchTerm(term: string) {
    this.searchTerm = term;
    this.resetPagination();
  }

  resetPagination() {
    this.pendingPage = 0;
    this.submittedJobPage = 0;
    this.newPage = 0;
    this.assignedPage = 0;
    this.readyForReviewPage = 0;
    this.approvedPage = 0;
  }

  reset() {
    this.mainTab = 0;
    this.pendingRowsPerPage = 50;
    this.submittedJobRowsPerPage = 50;
    this.newRowsPerPage = 50;
    this.assignedRowsPerPage = 50;
    this.readyForReviewRowsPerPage = 50;
    this.approvedRowsPerPage = 50;
    this.searchTerm = '';
    this.selectedSort = String(TeamsSortBy.NEWEST_FIRST);
    this.percentage = defaultPercentage;
    this.resetPagination();
  }

  setSelectedSort(sort: string) {
    this.selectedSort = sort;
  }

  setPercentage(value: string) {
    this.percentage = value;
  }
}

export const supportJobQueueService = new SupportJobQueueService();
